// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"123":"070f65db","453":"b2c3d116","667":"6e8bf3ae","726":"9fb8d723","812":"2218e91f","896":"b0527138","977":"1c1d2f01"}[chunkId] + ".chunk.js";
};